"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryFetchHttpHandler = exports.CALLER_ABORTED = void 0;
const tslib_1 = require("tslib");
const sentry_fetch_1 = tslib_1.__importDefault(require("@amzn/sentry-fetch"));
const HEADERS_TO_EXCLUDE = [
    "amz-sdk-invocation-id",
    "amz-sdk-request",
    "authorization",
    "x-amz-content-sha256",
    "x-amz-date",
    "x-amz-user-agent"
];
exports.CALLER_ABORTED = "Caller aborted";
class SentryFetchHttpHandler {
    constructor() {
        this.headersToPush = {};
    }
    /**
     * Will append (or overwrite) headers to every request
     * @param key The header name
     * @param value The header value
     */
    pushHeader(key, value) {
        this.headersToPush[key] = value;
    }
    async handle(request, handlerOptions) {
        // url
        const port = request.port ? `:${request.port}` : "";
        const url = new URL(`${request.protocol}${request.hostname}${port}${request.path}${this.parseQueryParameterBag(request.query)}`);
        // headers
        request.headers["Origin"] = `${window.location.protocol}${window.location.host}`;
        if (this.headersToPush) {
            for (const key in this.headersToPush) {
                if (Object.prototype.hasOwnProperty.call(this.headersToPush, key)) {
                    const value = this.headersToPush[key];
                    request.headers[key] = value;
                }
            }
        }
        const headers = this.parseRequestHeaders(request.headers);
        // Abort
        let signal;
        if (handlerOptions === null || handlerOptions === void 0 ? void 0 : handlerOptions.abortSignal) {
            const controller = new AbortController();
            signal = controller.signal;
            handlerOptions.abortSignal.onabort = (event) => {
                controller.abort(exports.CALLER_ABORTED);
            };
        }
        // Request options
        const init = {
            credentials: "include",
            mode: "cors",
            method: request.method,
            body: request.body,
            headers: headers,
            signal: signal
        };
        const response = await sentry_fetch_1.default(url, init);
        const result = {
            response: {
                statusCode: response.status,
                headers: this.parseResponseHeadersToHeaderBag(response.headers),
                body: response.body
            }
        };
        return result;
    }
    parseQueryParameterBag(query) {
        const q = [];
        for (const key in query) {
            if (Object.prototype.hasOwnProperty.call(query, key)) {
                const element = query[key];
                if (Array.isArray(element)) {
                    element.forEach(val => {
                        q.push(key + "=" + val);
                    });
                }
                else if (element) {
                    q.push(key + "=" + element);
                }
            }
        }
        if (q.length > 0)
            return "?" + q.join("&");
        else
            return "";
    }
    parseRequestHeaders(headers) {
        const bag = [];
        for (const key in headers) {
            if (Object.prototype.hasOwnProperty.call(headers, key)) {
                const element = headers[key];
                if (HEADERS_TO_EXCLUDE.indexOf(key.toLowerCase()) >= 0)
                    continue; // exclude this
                bag.push([key, element]);
            }
        }
        return bag;
    }
    parseResponseHeadersToHeaderBag(headers) {
        const bag = {};
        headers.forEach((value, key, parent) => {
            bag[key] = value;
        });
        return bag;
    }
}
exports.SentryFetchHttpHandler = SentryFetchHttpHandler;
//# sourceMappingURL=sentryfetch-http-handler.js.map